import { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@mui/material";

/**
 * 
 * @param {{ text?: string | JSX.Element, isOpen?: boolean, onClose?: () => void }} props 
 * @returns 
 */
const MessageDialog = (props) => {
  const { isOpen, text, onClose } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (text) setOpen(true);
  }, [text]);

  useEffect(() => {
    if (isOpen) setOpen(true);
    else setOpen(false);
  }, [isOpen]);

  const handleClose = () => {
    setOpen(false);
    onClose && onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        className="message-dialog"
      >
        <DialogContent>
          <div className="message-dialog-text">
            {text}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MessageDialog;
